import React, { forwardRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentCalendarAddFilled = forwardRef<Svg, { fillColor?: string; color?: string; size?: number } & SvgProps>(
  (
    {
      fillColor = '#212121',
      color = fillColor,
      size = 24,
      ...props
    }: { fillColor?: string; color?: string; size?: number } & SvgProps,
    ref
  ) => (
    <Svg
      ref={ref}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <Path
        d='M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM21 8.5l.001 3.523a6.5 6.5 0 00-8.979 8.979L6.25 21A3.25 3.25 0 013 17.75V8.5h18zM17.5 14l-.09.008a.5.5 0 00-.402.402L17 14.5V17h-2.5l-.09.008a.5.5 0 00-.402.402L14 17.5l.008.09a.5.5 0 00.402.402l.09.008H17v2.5l.008.09a.5.5 0 00.402.402l.09.008.09-.008a.5.5 0 00.402-.402L18 20.5V18h2.5l.09-.008a.5.5 0 00.402-.402L21 17.5l-.008-.09a.5.5 0 00-.402-.402L20.5 17H18v-2.5l-.008-.09a.5.5 0 00-.402-.402L17.5 14zm.25-11A3.25 3.25 0 0121 6.25V7H3v-.75A3.25 3.25 0 016.25 3h11.5z'
        fill={color}
      />
    </Svg>
  )
)

export default FluentCalendarAddFilled
